import { League } from '../types/League';
import { RankingData } from '../types/RankingData';
import { RequestLeague } from '../types/RequestLeague';
import { apiDelete, apiGet, apiPost, apiPostFormData, apiPostVoid } from './apiClient';

export interface CreateLeagueRequest {
  name: string;
  description: string;
  leagueImageUrl: string;
  adminId: string;
}

export interface LeagueRankingResponse {
  rankingRows: RankingData[];
}

export function getAllLeagues(): Promise<League[]> {
  return apiGet<League[]>('/api/League/All');
}

export function getLeagueById(id: number): Promise<League> {
  return apiGet<League>(`/api/League/${id}`);
}

export function getGeneralLeague(): Promise<League> {
  return apiGet<League>('/api/League/General');
}

export function createLeague(body: CreateLeagueRequest): Promise<League> {
  return apiPost<League>('/api/League', body);
}

export function deleteLeague(id: number): Promise<void> {
  return apiDelete(`/api/League/${id}`);
}

export function getLeagueRequests(leagueId: number): Promise<RequestLeague[]> {
  return apiGet<RequestLeague[]>(`/api/League/Request/All/League/${leagueId}`);
}

export function joinLeague(userId: string, leagueId: number): Promise<void> {
  return apiPostVoid('/api/League/Request/Join', { userId, leagueId });
}

export function acceptLeagueRequest(leagueId: number, userId: string): Promise<void> {
  return apiPostVoid('/api/League/Request/Accept', { leagueId, userId });
}

export function rejectLeagueRequest(leagueId: number, userId: string): Promise<void> {
  return apiPostVoid('/api/League/Request/Reject', { leagueId, userId });
}

export function removeUsersFromLeague(leagueId: number, usersId: string[]): Promise<void> {
  return apiDelete(`/api/League/Users/${leagueId}`, { leagueId, usersId });
}

export function getLeagueRanking(leagueId: number): Promise<LeagueRankingResponse> {
  return apiGet<LeagueRankingResponse>(`/api/LeagueRanking/${leagueId}`, true, {
    bypassCache: true,
  });
}

export async function uploadLeagueImage(
  leagueId: number,
  file: File
): Promise<{ leagueImageUrl: string }> {
  const formData = new FormData();
  formData.append('File', file);
  formData.append('LeagueID', leagueId.toString());

  return apiPostFormData<{ leagueImageUrl: string }>('/api/Image/LeagueImg', formData);
}
